import { useState } from "react";
import { useSupabaseClient } from "@/hooks/useSupabaseClient";

const supabase = useSupabaseClient();

export default function AdminColumns() {

  return (
    <section className="admin-section">
      Colonnes
    </section>
  );
}